import React, { useState } from 'react'
import { DropdownButton, Spinner } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons'
import { useSelector } from 'react-redux'
import { IMainState } from 'store/states'
import styles from './Option.module.scss'
import { useTranslation } from 'react-i18next'

interface IProps {
  item: any
  onDeleteClick: any
  onEditClick: any
  disable: boolean
}

const Options: React.FC<IProps> = ({
  item,
  onDeleteClick,
  onEditClick,
  disable = false,
}) => {
  const { t } = useTranslation()

  const { permission } = useSelector(({ user }: IMainState) => user)

  const [loading] = useState(false)

  const [show, setShow] = useState(false)

  const is_admin = permission.admin || permission.superadmin

  const handleDropdownClick = (show: boolean) => {
    if (!disable) {
      setShow(show)
    }
  }

  return (
    <DropdownButton
      id="dropdown-menu-align-right"
      show={show}
      alignRight
      disabled={disable}
      className={styles.actionSelect}
      title={
        !loading ? (
          <FontAwesomeIcon icon={faEllipsisV} size="1x" className="mr-2" />
        ) : (
          <div className="d-flex justify-content-center">
            <Spinner size={'sm'} animation="border" role="status">
              <span className="sr-only">
                {t('administration.folders.options.loading')}
              </span>
            </Spinner>
          </div>
        )
      }
      onClick={() => handleDropdownClick(!show)}
      onToggle={() => handleDropdownClick(!show)}
    >
      {show && (
        <>
          {is_admin && item.id != 1 && (
            <a onClick={() => onDeleteClick(item.id || 0)}>
              {t('administration.folders.options.delete')}
            </a>
          )}
          {is_admin && (
            <a onClick={() => onEditClick(item.id || 0)}>
              {t('administration.folders.options.edit')}
            </a>
          )}
        </>
      )}
    </DropdownButton>
  )
}

export default Options
